import { createReducer } from '../utils/createReducer';
import { keyById, setError, setLoading } from '../utils/helpers';
import {
  REQUEST_WEB_CARDS,
  REQUEST_WEB_CARDS_FAIL,
  REQUEST_WEB_CARDS_SUCCESS,
  REQUEST_WEB_CARD,
  REQUEST_WEB_CARD_FAIL,
  REQUEST_WEB_CARD_SUCCESS,
  DELETE_WEB_CARD,
  DELETE_WEB_CARD_SUCCESS,
  DELETE_WEB_CARD_FAIL,
  CREATE_WEB_CARD,
  CREATE_WEB_CARD_SUCCESS,
  CREATE_WEB_CARD_FAIL,
  UPDATE_WEB_CARD,
  UPDATE_WEB_CARD_SUCCESS,
  UPDATE_WEB_CARD_FAIL,
  SORT_WEB_CARD,
  SORT_WEB_CARD_SUCCESS,
  SORT_WEB_CARD_FAIL,
} from '../actionTypes';
import { arrayMove } from '../../helpers/list';

const initialState = {
  loading: false,
  error: null,
  ids: [],
  data: {},
};

export const reducer = createReducer(initialState, {
  [REQUEST_WEB_CARDS]: setLoading,
  [REQUEST_WEB_CARDS_FAIL]: setError,
  [REQUEST_WEB_CARDS_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    errors: null,
    data: keyById(action.payload.data),
    ids: action.payload.data.sort((elA, elB) => elA.order - elB.order).map(({ id }) => id),
  }),

  [REQUEST_WEB_CARD]: setLoading,
  [REQUEST_WEB_CARD_FAIL]: setError,
  [REQUEST_WEB_CARD_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    errors: null,
    data: { ...state.data, [action.payload.id]: action.payload },
    ids: state.ids.includes(action.payload.id) ? state.ids : state.ids.concat(action.payload.id),
  }),

  [DELETE_WEB_CARD]: setLoading,
  [DELETE_WEB_CARD_FAIL]: setError,
  [DELETE_WEB_CARD_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    errors: null,
    ids: state.ids.filter((id) => id !== action.payload),
  }),

  [CREATE_WEB_CARD]: setLoading,
  [CREATE_WEB_CARD_FAIL]: setError,
  [CREATE_WEB_CARD_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    errors: null,
    data: { ...state.data, [action.payload.id]: action.payload },
    ids: state.ids.concat(action.payload.id),
  }),

  [UPDATE_WEB_CARD]: setLoading,
  [UPDATE_WEB_CARD_FAIL]: setError,
  [UPDATE_WEB_CARD_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    errors: null,
    data: { ...state.data, [action.payload.id]: action.payload.data },
  }),

  [SORT_WEB_CARD]: (state, action) => ({
    ...state,
    loading: true,
    errors: null,
    ids: arrayMove(state.ids, action.payload.oldIndex, action.payload.newIndex),
  }),
  [SORT_WEB_CARD_FAIL]: (state, action) => ({
    ...state,
    loading: false,
    errors: action.payload.message,
    ids: arrayMove(state.ids, action.payload.newIndex, action.payload.oldIndex),
  }),
  [SORT_WEB_CARD_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    errors: null,
    data: { ...state.data, ...action.payload },
  }),
});
